import React, { CSSProperties, PropsWithChildren, RefObject } from 'react';
import bem from '../../../lib/bemUtils/bem';

type TableRow = {
  modifier?: any;
  id?: string;
  className?: string;
  style?: CSSProperties;
  ref?: RefObject<HTMLTableRowElement | null>
  tabIndex?: number;
};

export function TableRow({ children, modifier, className, id, style, ref, tabIndex }: PropsWithChildren<TableRow>) {
  return (
    <tr id={id} className={className || bem('tables__row', modifier)} style={style} ref={ref} tabIndex={tabIndex}>
      {children}
    </tr>
  );
}
